export default __webpack_public_path__ + "static/media/pharmacy.a04ec9c0.svg";